<template>
  <div class="table-links">
    <heading v-if="title" :title="title" level="h2" />
    <table v-for="(group, index) in tableGroup" :key="`accordions_${index}`">
      <heading v-if="group.title" :title="group.title" level="h3" />
      <div class="accordion">
        <tr
          v-for="(item, index) in group.links"
          :key="`accordion_${index}`"
          v-bind="item"
          class="accordion"
        >
          <td v-html="item.title"></td>
          <td class="font-bold" v-html="item.value"></td>
        </tr>
      </div>
    </table>
  </div>
</template>

<script>
import Heading from '@/components/heading/Heading.vue'
import Accordions from '@/sections/accordions/Accordions'
import Accordion from '@/components/partials/Accordion'
import Button from '@/components/partials/Button'

export default {
  name: 'SectionTable',
  components: {
    Heading,
    Accordions,
    Accordion,
    Button
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    tableGroup: {
      type: Array,
      default: () => []
    },
    buttons: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.table-links {
  table {
    width: 100%;
  }
  tr {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: $accordion-item-padding;
    border-bottom: $accordion-border-color solid $accordion-border-width;
  }
  td {
    width: 40%;
    & + td {
      width: 60%;
    }
  }
}
</style>
